import React from 'react'

const Flexbox_Coding_Assignment_3 = () => {
  return (
    <div>
      <h1>Coding Assignment 3</h1>
    </div>
  )
}

export default Flexbox_Coding_Assignment_3
